module.exports = __webpack_public_path__ + "img/delivery-deliveroo.fe942bb3.svg";